const state = {
    labor: 'unspecialized', // unspecialized, factory-certified
    hoverLabor: null,
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {
  setLabor(state, labor) {
    state.labor = labor
  },
  setHoverLabor(state, hoverLabor) {
      state.hoverLabor = hoverLabor
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}